import React, { Component } from "react";
import Modal from "react-modal";
import { requestAccess } from "../helper/access_helper";
import Loader from "../components/loader";
import { renderErrorMessage } from "../helper/user_helper";

import Logo from "../design/img/yay-transparent.png";

class ModalRequestAccess extends Component {
  state = {
    email: "",
    first_name: "",
    last_name: "",
    instagram_handle: "",
    loading: false,
    success: false,
    error: ""
  };

  renderForm() {
    return (
      <form className="sign_up_div mt-3 mb-3" onSubmit={this.submitRequet}>
        <label className={"yaystack_input_text_label mt-3"}>
          <input
            className="yaystack_input_text mb-3"
            type="text"
            required={true}
            value={this.state.first_name}
            placeholder={"First Name"}
            onChange={this.handleChangeFirstName}
          />
        </label>
        <br />
        <label className="yaystack_input_text_label">
          <input
            className="yaystack_input_text mb-3"
            type="text"
            required={true}
            value={this.state.last_name}
            placeholder={"Last Name"}
            onChange={this.handleChangeLastName}
          />
        </label>
        <br />
        <label className={"yaystack_input_text_label"}>
          <input
            className="yaystack_input_text mb-3"
            type="text"
            required={true}
            value={this.state.email}
            placeholder={"Email"}
            onChange={this.handleChangeEmail}
          />
        </label>
        <br />
        <label className="yaystack_input_text_label">
          <input
            className="yaystack_input_text mb-3"
            type="text"
            required={true}
            value={this.state.instagram_handle}
            placeholder={"Instagram Handle"}
            onChange={this.handleChangeInstagramHandle}
          />
        </label>
        {renderErrorMessage(this.state.error)}
        {this.state.loading ? (
          <div style={{ marginTop: "-100px" }}>
            <Loader />
          </div>
        ) : (
          <input
            type="submit"
            value={"Request"}
            className="btn btn_primary btn_yaystack mb-3"
            style={{
              fontFamily: "DIN Pro Bold",
              borderRadius: "10px",
              paddingLeft: "30px",
              paddingRight: "30px",
              paddingTop: "10px",
              paddingBottom: "10px",
              fontSize: "22px"
            }}
          />
        )}
      </form>
    );
  }

  renderSuccess() {
    return (
      <div className="mb-3 mt-3 ml-3 mr-3">
        <div>
          <img
            className="max_width_300"
            src={Logo}
            alt="Yaystack Logo"
            style={{ marginBottom: "20%", marginTop: "10%" }}
          />
        </div>
        <label
          style={{
            color: "#282560",
            fontFamily: "DIN Pro Light",
            fontSize: "22px"
          }}
        >
          We’ll email you in the near future!
        </label>
      </div>
    );
  }
  render() {
    return (
      <Modal className="follow-views" isOpen={this.props.openModal}>
        <div className="follow-return" onClick={this.handleCloseModal} />
        <div className="follow-view modal-media center comment_modal">
          {this.state.success ? this.renderSuccess() : this.renderForm()}
        </div>
      </Modal>
    );
  }

  //---FUNCTION
  handleChangeEmail = event => {
    this.setState({ email: event.target.value });
  };
  handleChangeFirstName = event => {
    this.setState({ first_name: event.target.value });
  };
  handleChangeLastName = event => {
    this.setState({ last_name: event.target.value });
  };
  handleChangeInstagramHandle = event => {
    this.setState({ instagram_handle: event.target.value });
  };
  handleCloseModal = _ => {
    this.setState({
      email: "",
      first_name: "",
      last_name: "",
      instagram_handle: "",
      error: ""
    });
    this.props.handleCloseModal();
  };

  submitRequet = event => {
    event.preventDefault();
    this.setState({ loading: true, error: "" });
    var fd = new FormData();
    fd.append("access_request[email]", this.state.email);
    fd.append("access_request[first_name]", this.state.first_name);
    fd.append("access_request[last_name]", this.state.last_name);
    fd.append("access_request[instagram]", this.state.instagram_handle);
    this.getAccess = requestAccess(fd);
    this.getAccess.promise
      .then(answer => {
        this.setState({ loading: false, success: true });
      })
      .catch(error => {
        this.setState({ loading: false, error: error.errors });
      });
  };

  //FUNCTION---
}

export default ModalRequestAccess;



// WEBPACK FOOTER //
// ./src/modal/ModalRequestAccess.jsx